(function() {
  "use strict";

  // Skip popup in Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  var CONFIG = {
    klaviyoKey: "pk_ff5f20cdff05c904dba99088c3f0f79e55",
    klaviyoListId: "Uxh3uZ",
    triggerDelay: 28000,
    scrollTrigger: 999, // disabled — time + exit-intent only
    cookieDays: 365,
    dismissDays: 7,
    hiddenPages: ["/cart", "/checkout", "/checkouts", "/account"],
    heroImage: "https://cdn.shopify.com/s/files/1/0756/0288/6939/files/Untitled_design_18.png?v=1778129188&width=600",
  };

  function getCookie(name) {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
  }

  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function lsSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  // Mark opted-in as soon as email is submitted (not only on the final confirmation).
  // Cookie + localStorage so clearing one store alone doesn't bring the popup back.
  function markSignedUp() {
    setCookie("muse_popup_signed_up", "1", CONFIG.cookieDays);
    lsSet("muse_popup_signed_up", "1");
  }

  function hasSignedUp() {
    return !!(getCookie("muse_popup_signed_up") || lsGet("muse_popup_signed_up"));
  }

  function shouldShow() {
    if (window.MUSE_CUSTOMER_LOGGED_IN) return false;
    if (hasSignedUp()) return false;
    if (getCookie("muse_popup_dismissed") || lsGet("muse_popup_dismissed")) return false;
    var path = window.location.pathname.toLowerCase();
    if (CONFIG.hiddenPages.some(function(p) { return path.includes(p); })) return false;
    return true;
  }

  if (!shouldShow()) return;

  var customerEmail = "";

  var style = document.createElement("style");
  style.textContent = "\
    #mp-overlay {\
      position:fixed;top:0;left:0;right:0;bottom:0;\
      background:rgba(0,0,0,0.5);z-index:2147483646;\
      display:none;justify-content:center;align-items:center;\
    }\
    #mp-overlay.show{display:flex;}\
    #mp-box{\
      background:#fff;max-width:720px;width:94%;position:relative;\
      box-shadow:0 16px 50px rgba(0,0,0,0.25);overflow:visible;\
      border-radius:4px;\
      min-height:380px;\
      contain:layout style;\
    }\
    #mp-close{\
      position:absolute;top:6px;right:6px;z-index:10;\
      background:#E8A435;color:#fff;border:none;width:26px;height:26px;\
      font-size:16px;cursor:pointer;display:flex;align-items:center;\
      justify-content:center;line-height:1;\
    }\
    .mp-split{\
      position:relative;\
      overflow:visible;\
      min-height:240px;\
    }\
    .mp-left{\
      width:58%;padding:28px 28px 24px;display:flex;flex-direction:column;\
      justify-content:center;z-index:2;text-align:left;\
      position:relative;\
    }\
    .mp-right{\
      position:absolute;bottom:0;right:5%;;\
      width:42%;z-index:1;\
      pointer-events:none;\
    }\
    .mp-right img{\
      display:block;width:100%;height:auto;\
      margin-bottom:0;margin-top:-8%;\
      aspect-ratio:1 / 1;object-fit:contain;\
    }\
    .mp-full{\
      padding:32px 40px;text-align:center;border:3px solid #E8A435;\
    }\
    .mp-h1{\
      font-family:'Inter',sans-serif;\
      font-size:28px;font-weight:800;color:#111;\
      margin:0 0 10px;line-height:1.1;text-transform:uppercase;\
      text-align:left;\
    }\
    .mp-h1-lg{font-size:30px;margin-bottom:10px;}\
    .mp-sub{\
      font-family:'Inter',sans-serif;\
      font-size:14px;color:#111;margin:0 0 4px;line-height:1.5;font-weight:600;\
      text-align:left;\
    }\
    .mp-small{\
      font-family:'Open Sans',sans-serif;\
      font-size:12px;color:#888;margin:0 0 18px;line-height:1.4;\
      font-weight:400;text-align:left;\
    }\
    .mp-p{\
      font-family:'Open Sans',sans-serif;\
      font-size:13px;color:#555;margin:0 0 14px;line-height:1.5;\
    }\
    .mp-input{\
      width:100%;padding:12px 14px;border:1.5px solid #ccc;\
      font-size:15px;box-sizing:border-box;margin-bottom:10px;\
      outline:none;font-family:'Open Sans',sans-serif;color:#333;\
      background:#fff;border-radius:6px;\
    }\
    .mp-input:focus{border-color:#111;}\
    .mp-input::placeholder{color:#999;}\
    .mp-btn{\
      width:100%;padding:14px;border:none;\
      background:#FAE9EF;color:#222;\
      font-size:14px;font-weight:700;cursor:pointer;\
      font-family:'Inter',sans-serif;text-transform:uppercase;\
      letter-spacing:1px;border-radius:30px;margin-bottom:8px;\
      text-align:center;\
    }\
    .mp-btn:hover{background:#f5dce5;}\
    .mp-btn-lg{\
      font-size:16px;padding:15px;letter-spacing:1.5px;\
    }\
    .mp-skip{\
      background:none;border:none;color:#999;font-size:10px;\
      cursor:pointer;margin-top:4px;padding:2px;\
      font-family:'Open Sans',sans-serif;\
      letter-spacing:0.3px;\
    }\
    .mp-consent{\
      font-size:9px;color:#aaa;margin-top:14px;line-height:1.4;\
      font-family:'Open Sans',sans-serif;\
    }\
    .mp-highlight{\
      border:1.5px solid #ccc;padding:10px 14px;margin-bottom:14px;\
      font-family:'Inter',sans-serif;font-size:15px;font-weight:700;\
      color:#111;text-transform:uppercase;letter-spacing:0.5px;\
      text-align:center;\
    }\
    .mp-confirm-h2{\
      font-family:'Inter',sans-serif;\
      font-size:36px;font-weight:800;color:#111;\
      margin:0 0 6px;text-transform:uppercase;\
    }\
    .mp-confirm-h3{\
      font-family:'Inter',sans-serif;\
      font-size:20px;font-weight:700;color:#111;\
      margin:0 0 14px;\
    }\
    .mp-error{border-color:#BC2020!important;}\
    @media(max-width:580px){\
      #mp-box *, #mp-box *::before, #mp-box *::after{box-sizing:border-box;}\
      #mp-box{max-width:320px;width:92%;overflow:hidden;border-radius:8px;min-height:500px;}\
      #mp-close{width:28px;height:28px;font-size:16px;top:6px;right:6px;}\
      .mp-split{display:flex;flex-direction:column;min-height:auto;position:relative;width:100%;}\
      .mp-right{position:relative;top:auto;left:auto;transform:none;width:140px;max-width:140px;margin:18px auto 0;display:block;pointer-events:none;z-index:1;order:0;}\
      .mp-right img{width:100%;height:auto;display:block;margin:0;}\
      .mp-left{width:100%;padding:8px 20px 20px;text-align:center;order:1;}\
      .mp-full{width:100%;padding:24px 18px;}\
      .mp-h1{font-size:22px;text-align:center;}\
      .mp-h1-lg{font-size:24px;}\
      .mp-sub{text-align:center;font-size:13px;}\
      .mp-small{text-align:center;}\
      .mp-confirm-h2{font-size:28px;}\
      .mp-confirm-h3{font-size:18px;}\
      .mp-btn{font-size:13px;padding:12px;}\
      .mp-btn-lg{font-size:14px;padding:14px;letter-spacing:1.2px;}\
      .mp-input{font-size:16px;padding:11px 12px;}\
    }\
  ";
  document.head.appendChild(style);

  var overlay = document.createElement("div");
  overlay.id = "mp-overlay";
  overlay.innerHTML = '<div id="mp-box"><button id="mp-close">\u00d7</button><div id="mp-content"></div></div>';
  document.body.appendChild(overlay);

  var content = document.getElementById("mp-content");

  document.getElementById("mp-close").addEventListener("click", function() {
    overlay.classList.remove("show"); window.musePopupActive = false;
    setCookie("muse_popup_dismissed", "1", CONFIG.dismissDays); lsSet("muse_popup_dismissed", "1");
  });

  overlay.addEventListener("click", function(e) {
    if (e.target === overlay) {
      overlay.classList.remove("show"); window.musePopupActive = false;
      setCookie("muse_popup_dismissed", "1", CONFIG.dismissDays); lsSet("muse_popup_dismissed", "1");
    }
  });

  function showStep1() {
    content.innerHTML =
      '<div class="mp-split">' +
      '  <div class="mp-left">' +
      '    <h2 class="mp-h1">YOU HAVE UNLOCKED A SECRET DISCOUNT!</h2>' +
      '    <p class="mp-sub">Drop your email below and we will send your discount.</p>' +
      '    <p class="mp-small">First-timers only. No spam, just the good stuff.</p>' +
      '    <input type="email" class="mp-input" id="mp-email" placeholder="Enter Email Here" />' +
      '    <button class="mp-btn" id="mp-reveal">UNLOCK MY DISCOUNT</button>' +
      '    <button class="mp-skip" id="mp-skip1">No thanks, I hate discounts</button>' +
      '  </div>' +
      '  <div class="mp-right">' +
      '    <img src="' + CONFIG.heroImage + '" alt="Muse For Hair" />' +
      '  </div>' +
      '</div>';

    document.getElementById("mp-reveal").addEventListener("click", function() {
      var email = document.getElementById("mp-email").value.trim();
      if (!email || !email.includes("@") || !email.includes(".")) {
        document.getElementById("mp-email").classList.add("mp-error");
        return;
      }
      customerEmail = email;
      markSignedUp();
      submitToKlaviyo(email, "");
      showStep2();
    });

    document.getElementById("mp-email").addEventListener("keydown", function(e) {
      if (e.key === "Enter") document.getElementById("mp-reveal").click();
    });

    document.getElementById("mp-skip1").addEventListener("click", function() {
      overlay.classList.remove("show"); window.musePopupActive = false;
      setCookie("muse_popup_dismissed", "1", CONFIG.dismissDays); lsSet("muse_popup_dismissed", "1");
    });
  }

  function showStep2() {
    content.innerHTML =
      '<div class="mp-split">' +
      '  <div class="mp-left">' +
      '    <h2 class="mp-h1">GET AN EVEN BIGGER DISCOUNT</h2>' +
      '    <p class="mp-sub">Become a Muse VIP and be the first to hear about new releases, sales and members-only offers.</p>' +
      '    <p class="mp-small">Text-only updates. Opt out anytime.</p>' +
      '    <button class="mp-btn" id="mp-upgrade">MAKE ME A VIP</button>' +
      '    <button class="mp-skip" id="mp-skip2">NO THANKS, I\'LL PASS ON VIP</button>' +
      '  </div>' +
      '  <div class="mp-right">' +
      '    <img src="' + CONFIG.heroImage + '" alt="Muse For Hair" />' +
      '  </div>' +
      '</div>';

    document.getElementById("mp-upgrade").addEventListener("click", showStep3);
    document.getElementById("mp-skip2").addEventListener("click", showEmailConfirmation);
  }

  function showEmailConfirmation() {
    markSignedUp();
    content.innerHTML =
      '<div class="mp-full" style="padding:44px 40px;">' +
      '  <h2 class="mp-confirm-h2">CHECK YOUR INBOX!</h2>' +
      '  <h3 class="mp-confirm-h3">Your discount is on the way.</h3>' +
      '  <p class="mp-p">Your welcome discount just got sent to your email. Click the link inside and your discount will be automatically applied at checkout.</p>' +
      '  <button class="mp-btn mp-btn-lg" id="mp-shopping">TAKE ME SHOPPING</button>' +
      '</div>';

    document.getElementById("mp-shopping").addEventListener("click", function() {
      overlay.classList.remove("show"); window.musePopupActive = false;
    });
  }

  function showStep3() {
    content.innerHTML =
      '<div class="mp-full">' +
      '  <h2 class="mp-h1 mp-h1-lg">UPGRADE YOUR DISCOUNT:</h2>' +
      '  <div class="mp-highlight">ENTER YOUR BEST PHONE NUMBER BELOW</div>' +
      '  <p class="mp-p">Enter your best number below and we will send you an upgraded discount!</p>' +
      '  <div style="display:flex;gap:0;margin-bottom:12px;">' +
      '    <select id="mp-country" style="padding:12px 8px;border:1.5px solid #ccc;border-right:none;border-radius:6px 0 0 6px;font-size:15px;background:#fff;outline:none;font-family:Open Sans,sans-serif;color:#333;min-width:90px;-webkit-appearance:none;appearance:none;background-image:url(\'data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>\');background-repeat:no-repeat;background-position:right 4px center;background-size:16px;padding-right:22px;">' +
      '      <option value="+61">\ud83c\udde6\ud83c\uddfa +61</option>' +
      '      <option value="+1">\ud83c\uddfa\ud83c\uddf8 +1</option>' +
      '      <option value="+44">\ud83c\uddec\ud83c\udde7 +44</option>' +
      '      <option value="+64">\ud83c\uddf3\ud83c\uddff +64</option>' +
      '      <option value="+353">\ud83c\uddee\ud83c\uddea +353</option>' +
      '      <option value="+91">\ud83c\uddee\ud83c\uddf3 +91</option>' +
      '      <option value="+65">\ud83c\uddf8\ud83c\uddec +65</option>' +
      '      <option value="+971">\ud83c\udde6\ud83c\uddea +971</option>' +
      '      <option value="+49">\ud83c\udde9\ud83c\uddea +49</option>' +
      '      <option value="+33">\ud83c\uddeb\ud83c\uddf7 +33</option>' +
      '    </select>' +
      '    <input type="tel" class="mp-input" id="mp-phone" placeholder="Enter Your Best Phone Number..." style="margin-bottom:0;border-radius:0 6px 6px 0;" />' +
      '  </div>' +
      '  <button class="mp-btn mp-btn-lg" id="mp-textcode">TEXT MY CODE</button>' +
      '  <p class="mp-consent">By providing your phone number or submitting this form, you agree to receive recurring automated marketing text messages (e.g. cart reminders) from this shop and third parties acting on its behalf at the phone number provided. Consent is not a condition to obtain goods or services. Msg & data rates may apply. Msg frequency varies. Reply HELP for help and STOP to cancel. You also agree to the Terms of Service and Privacy Policy.</p>' +
      '</div>';

    document.getElementById("mp-textcode").addEventListener("click", function() {
      var countryCode = document.getElementById("mp-country").value;
      var phone = document.getElementById("mp-phone").value.trim().replace(/^0+/, "");
      if (!phone || phone.length < 6) {
        document.getElementById("mp-phone").classList.add("mp-error");
        return;
      }
      var fullPhone = countryCode + phone;
      submitToKlaviyo(customerEmail, fullPhone);
      showStep4();
    });
  }

  function showStep4() {
    markSignedUp();
    content.innerHTML =
      '<div class="mp-full" style="padding:44px 40px;">' +
      '  <h2 class="mp-confirm-h2">YOU\'RE IN!</h2>' +
      '  <h3 class="mp-confirm-h3">You\'ll get a text any second now...</h3>' +
      '  <p class="mp-p">Thanks for joining our family! Your UPGRADED discount code is on the way, please check your phone for a message from us. Click the link inside and your discount will be automatically applied at checkout.</p>' +
      '  <button class="mp-btn mp-btn-lg" id="mp-done">CLOSE</button>' +
      '</div>';

    document.getElementById("mp-done").addEventListener("click", function() {
      overlay.classList.remove("show"); window.musePopupActive = false;
    });
  }

  function submitToKlaviyo(email, phone) {
    fetch("https://muse-chatbot-production.up.railway.app/api/popup-subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, phone: phone || "" }),
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status === "ok") {
        console.log("Popup subscription success");
      } else {
        console.error("Popup subscription error:", data.error);
      }
    })
    .catch(function(e) { console.error("Popup error:", e); });
  }

  // Pre-render Step 1 content into the hidden overlay NOW (not at trigger).
  // This makes the hero image start loading and fonts apply BEFORE the popup
  // is shown, so when .show is added at t=12s, no layout shift occurs.
  // CHG-005: warm the popup up AFTER the page has loaded (still well before the
  // 28s / exit-intent trigger) so its fonts + image don't compete with the page's
  // main image during the first seconds of loading.
  var warmedUp = false;
  function warmUp() {
    if (warmedUp) return;
    warmedUp = true;
    var fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "https://fonts.googleapis.com/css2?family=Inter:wght@600;700;800&family=Open+Sans:wght@400;500&display=swap";
    document.head.appendChild(fontLink);
    showStep1();
    var preheat = new Image();
    preheat.src = CONFIG.heroImage;
  }
  if (document.readyState === "complete") {
    setTimeout(warmUp, 1500);
  } else {
    window.addEventListener("load", function() { setTimeout(warmUp, 1500); });
  }

  // Trigger: ~28s dwell OR desktop exit-intent (no early scroll interrupt)
  var triggered = false;

  function triggerPopup() {
    if (triggered || !shouldShow()) return;
    triggered = true;
    warmUp();
    window.musePopupActive = true;
    overlay.classList.add("show");
  }

  setTimeout(triggerPopup, CONFIG.triggerDelay);

  // Desktop exit-intent: mouse leaves viewport at the top
  document.addEventListener("mouseout", function(e) {
    if (triggered) return;
    if (e.relatedTarget || e.toElement) return;
    if (typeof e.clientY === "number" && e.clientY > 0) return;
    // Skip coarse pointers (phones/tablets) — exit-intent is desktop-only
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;
    if (window.innerWidth < 768) return;
    triggerPopup();
  });

})();

// Updated 2026-10-27: 28s + exit-intent; signed-up persists from email submit (cookie+localStorage)